import type { ComponentPropsWithoutRef, FC } from 'react';
import { cn } from 'src/utils/cn';

type HintProps = ComponentPropsWithoutRef<'aside'> & {
  size?: 'sm' | 'md';
};

export const Hint: FC<HintProps> = ({ size = 'md', ...props }) => (
  <aside
    {...props}
    className={cn(
      `inline-block text-foreground-surface-subdued`,
      size === 'sm' && 'text-body-sm'
    )}
  />
);
